module.exports = __webpack_public_path__ + "img/home_carousel_image_1.c337f7fd.png";